<template>
  <div id="addBlockField">
    <div class="o-modal">
      <div class="o-modal-content">
        <div class="o-modal-header">
          <a
            @click="closeAddField()"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead">Add a Header</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <form @submit.prevent>

            <!-- Label -->
            <div class="form-group">
              <label>Header Label</label>
              <input
                v-model="field.label"
                class="form-control"
              />
            </div><!-- /.form-group -->

            <!-- Select Field Type -->
            <div class="form-group">
              <label>Header Type</label>
              <multiselect
                v-model="field.type"
                :options="fieldTypes"
                :allow-empty="false"
                :multiple="false"
              />
            </div><!-- /.form-group -->

            <!-- Select Options -->
            <div
              v-if="field.type === 'Select'"
              class="form-group"
            >
              <label>Header Options</label>
              <b-badge
                pill
                class="ml-1 clickable"
                v-if="editMode"
                @click="gatherOptions(field)"
                variant="primary"
              >Generate Options</b-badge>
              <multiselect
                v-model="field.options"
                :options="field.options"
                tag-placeholder="Add options here"
                placeholder="Add options here"
                :allow-empty="true"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
              />
            </div><!-- /.form-group -->

            <!-- Include Time -->
            <b-form-checkbox
              v-if="field.type === 'Date and Time'"
              v-model="field.includeTime"
              class="mt-2 mb-2"
            >
              Include Time
            </b-form-checkbox>

            <!-- Minimum Number -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Min</label>
              <input
                v-model="field.min"
                class="form-control"
                type="number"
              />
            </div><!-- /.form-group -->

            <!-- Maximum Number -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Max</label>
              <input
                v-model="field.max"
                class="form-control"
                type="number"
              />
            </div><!-- /.form-group -->

            <!-- Step Setting -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Step</label>
              <input
                v-model="field.step"
                class="form-control"
                type="number"
              />
            </div><!-- /.form-group -->

            <!-- Suffix -->
            <div
              v-if="field.type === 'Number'"
              class="form-group"
            >
              <label>Suffix</label>
              <input
                v-model="field.suffix"
                class="form-control"
              />
            </div><!-- /.form-group -->

            <!-- Header Group-->
            <div
              class="form-group"
            >
              <label>Header Group<br /><small>You may assign each header to one group.</small></label>
              <multiselect
                v-if="showSelects"
                v-model="field.group"
                :options="headerGroups"
                tag-placeholder="New Group"
                placeholder="Add Groups Here"
                :allow-empty="true"
                :multiple="false"
                :taggable="true"
                @tag="addHeaderGroup"
                @remove="refreshGroupsUI"
                @select="refreshGroupsUI"
              />
            </div><!-- /.form-group -->

            <!-- Required Option -->
            <b-form-checkbox
              v-model="field.required"
              class="mt-2 mb-2"
            >
              Required Header
            </b-form-checkbox>

            <!-- Dynamic Log Header (inherits type from header above) -->
            <b-form-checkbox
              v-model="field.isLogEnabled"
              class="mt-2 mb-2"
            >
              Enable Logging Over Time
            </b-form-checkbox>

          </form>
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <div class="drawer-footer">
            <button
              v-if="!editMode"
              @click="addField()"
              class="btn btn-primary mr-1 w-50"
            >
              Add Header
            </button>
            <button
              v-if="editMode"
              @click="addField()"
              class="btn btn-primary mr-1 w-50"
            >
              Update Header
            </button>
            <button
              v-if="editMode"
              @click="confirmRemove = true"
              class="btn btn-danger"
            >
              Remove Header
            </button>
          </div><!-- /.float-right -->
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /. o-modal -->
    <Confirm
      v-if="confirmRemove"
      text="DANGER! Are you sure you want to remove this field? THIS CANNOT BE UNDONE!!"
      v-on:confirmed="removeField($event)"
    />
  </div><!-- /#addBlockField -->
</template>

<script>
import Confirm from '../Confirm'
import Multiselect from 'vue-multiselect'

export default {
  data () {
    return {
      headerGroups: [],
      showSelects: true,
      confirmRemove: false,
      showRadio: true,
      fieldTypes: [
        'Text',
        'Number',
        'Select',
        'Date and Time',
        'Image'
      ],
      field: {
        label: '',
        type: 'Text',
        options: [],
        min: false,
        max: false,
        step: false,
        suffix: '',
        required: false,
        includeTime: false,
        group: false,
        isLogEnabled: false
      }
    }
  },
  components: {
    Multiselect,
    Confirm
  },
  props: [
    'editMode',
    'fieldIndex'
  ],
  computed: {
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'farm', value: value })
      }
    }
  },
  created () {
    if (this.editMode) {
      this.field = this.farm.blockFields[this.fieldIndex]
      if (typeof this.field.isLogEnabled !== 'boolean') this.field.isLogEnabled = false
    }
    this.farm.blockFields.forEach(field => {
      // SETUP GROUPS
      if (!field.group) {
        field.group = false
      } else {
        if (!this.headerGroups.includes(field.group)) {
          this.headerGroups.push(field.group)
        }
      }
    })
  },
  methods: {
    deriveLogValueType (headerType) {
      const t = (headerType || '').toLowerCase()
      if (t === 'number') return 'number'
      if (t === 'text') return 'text'
      if (t === 'select') return 'select'
      if (t === 'date and time') return 'datetime'
      if (t === 'image') return 'image'
      return 'text'
    },
    gatherOptions (field) {
      console.log(field)
      this.$store.state.blocksGeoJson.features.forEach(feature => {
        let alreadyGathered = false
        this.field.options.forEach(option => {
          if (option === feature.properties[field.label]) {
            alreadyGathered = true
          }
        })
        if (!alreadyGathered) {
          this.field.options.push(feature.properties[field.label])
        }
      })
    },
    removeField (confirmed) {
      if (confirmed) {
        this.confirmRemove = false
        this.farm.blockFields.splice(this.fieldIndex, 1)
        this.$store.commit('toggleModal', 'addBlockField')
      } else {
        this.confirmRemove = false
        return false
      }
    },
    addField () {
      // Validate that number fields with min and max also have step set
      if (this.field.type === 'Number' && (this.field.min || this.field.max) && !this.field.step) {
        // alert('You must enter min, max, and step. You may also leave all three of these settings blank.')
        this.$store.commit('setAlert', { active: true, message: 'You must enter min, max, and step. You may also leave all three of these settings blank.', level: 'alert-warning', timeout: 3000 })
        return false
      }
      // Look to see if special characters exist in labels. Replace with underscores.
      const regex = /[&\/\\#,+()$~%.'":*?<>{}]/g // eslint-disable-line
      const testRegexLabel = regex.test(this.field.label)
      if (testRegexLabel) {
        this.field.label = this.field.label.replace(regex, '_')
      }
      if (this.editMode) {
        const fieldObj = {
          label: this.field.label,
          type: this.field.type,
          machine_name: this.field.machine_name,
          min: this.field.min,
          max: this.field.max,
          step: this.field.step,
          suffix: this.field.suffix || false,
          required: this.field.required,
          includeTime: this.field.includeTime || false,
          group: this.field.group || false,
          isLogEnabled: this.field.isLogEnabled === true,
          logValueType: this.deriveLogValueType(this.field.type)
        }
        if (this.field.type === 'Select') {
          fieldObj.options = this.field.options
        } else {
          fieldObj.options = []
        }
        this.farm.blockFields[this.fieldIndex] = fieldObj
        this.$store.commit('toggleModal', 'addBlockField')
      } else {
        if (!this.field.label) {
          // alert('You must enter a label to create this field!')
          this.$store.commit('setAlert', { active: true, message: 'You must enter a label to create this field!', level: 'alert-warning', timeout: 3000 })
          return false
        } else if (this.field.label === 'ID' || this.field.label === 'id' || this.field.label === 'iD' || this.field.label === 'Id' || this.field.label === 'group') {
          this.$store.commit('setAlert', { active: true, message: 'The label "ID" is reserved for the system. Please change the label on this field. (example: "ID Code")', level: 'alert-warning', timeout: 6000 })
          return false
        } else {
          const snakeCase = string => {
            string = string.replace(/\W+/g, ' ').toLowerCase().split(' ').join('_')
            if (string.charAt(string.length - 1) === '_') {
              return string.substring(0, string.length - 1)
            }
            return string
          }
          let machineName = snakeCase(this.field.label)
          const originalMachineName = machineName
          // Check for other machine names of the same
          let suffix = 1
          const self = this
          function checkUniqueName () { // eslint-disable-line
            self.farm.blockFields.forEach((item, i) => {
              if (item.machine_name === machineName) {
                machineName = originalMachineName + '_' + suffix
                suffix++
                checkUniqueName()
              }
            })
          }
          checkUniqueName()

          const fieldObj = {
            label: this.field.label,
            type: this.field.type,
            machine_name: machineName,
            min: this.field.min,
            max: this.field.max,
            step: this.field.step,
            suffix: this.field.suffix || false,
            required: this.field.required,
            includeTime: this.field.includeTime || false,
            group: this.field.group || false,
            isLogEnabled: this.field.isLogEnabled === true,
            logValueType: this.deriveLogValueType(this.field.type)
          }
          if (this.field.type === 'Select') {
            fieldObj.options = this.field.options
          } else {
            fieldObj.options = []
          }

          this.farm.blockFields.push(fieldObj)
          this.$store.commit('toggleModal', 'addBlockField')
        }
      }
    },
    addTag (newTag) {
      this.field.options.push(newTag)
    },
    addHeaderGroup (newGroup) {
      this.showSelects = false
      if (!this.headerGroups.includes(newGroup)) {
        this.headerGroups.push(newGroup)
      }
      this.field.group = newGroup
      setTimeout(() => {
        this.showSelects = true
      }, 10)
    },
    refreshGroupsUI () {
      this.showSelects = false
      setTimeout(() => {
        this.showSelects = true
      }, 10)
    },
    closeAddField () {
      this.$store.commit('toggleModal', 'addBlockField')
    }
  }
}
</script>
